import { Component, OnInit, Input } from '@angular/core';
import { TaskProcessModalsService } from '../shared/task-process-modals.service';
import { Task } from '../shared/model';
import { TaskProcessContext } from '../shared/task-process-context.class';

/**
 * Either overlay in the right-hand side column (in desktop mode)
 * or modal as a card modal (if native or mobile mode)
 */
@Component({
  selector: 'app-public-context-and-task-actions',
  templateUrl: './public-context-and-task-actions.component.html',
  styleUrls: ['./public-context-and-task-actions.component.scss'],
})
export class PublicContextAndTaskActionsComponent implements OnInit {
  @Input() task: Task;
  @Input() taskProcessContext: TaskProcessContext;
  @Input() hasPublicContext: boolean;
  @Input() shouldSelectPublicContextTab: boolean;

  isPublicContextSelected: boolean;
  hasActionsLogBeenSelectedAtLeastOnce = false;
  hasPublicContextBeenSelectedAtLeastOnce = false;

  constructor(private taskProcessModalsService: TaskProcessModalsService) {}

  ngOnInit() {
    if (this.shouldSelectPublicContextTab) {
      this.selectPublicContext();
    } else {
      this.selectActionsLog();
    }
  }

  selectActionsLog() {
    this.hasActionsLogBeenSelectedAtLeastOnce = true;
    this.isPublicContextSelected = false;
  }

  selectPublicContext() {
    this.hasPublicContextBeenSelectedAtLeastOnce = true;
    this.isPublicContextSelected = true;
  }

  dismissModal() {
    this.taskProcessModalsService.dismissTaskProcessPageModal();
  }
}
